var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconappointmentbggreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.355103,
    y: 0.833893,
    width: 76,
    height: 76,
    rx: 25,
    fill: "#DBFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4338 24.466V20.2438M29.4338 24.466V20.2438M20.4616 30.7994H57.4061M19.9338 35.1145C19.9338 30.6495 19.9338 28.4159 20.8543 26.7101C21.6866 25.1887 22.978 23.9689 24.5445 23.2247C26.3516 22.3549 28.7161 22.3549 33.4449 22.3549H44.4227C49.1516 22.3549 51.5161 22.3549 53.3232 23.2247C54.9128 23.9889 56.2027 25.2091 57.0134 26.708C57.9338 28.418 57.9338 30.6516 57.9338 35.1166V45.4864C57.9338 49.9514 57.9338 52.1849 57.0134 53.8907C56.1811 55.4122 54.8896 56.632 53.3232 57.3761C51.5161 58.2438 49.1516 58.2438 44.4227 58.2438H33.4449C28.7161 58.2438 26.3516 58.2438 24.5445 57.374C22.9784 56.6304 21.6869 55.4114 20.8543 53.8907C19.9338 52.1807 19.9338 49.9471 19.9338 45.4821V35.1145Z",
    stroke: "#00A63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconappointmentbggreen);
export default __webpack_public_path__ + "static/media/Iconappointmentbggreen.8ac9a454d6aabda017a938d0d257bb7e.svg";
export { ForwardRef as ReactComponent };